// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-ui-Consult-styles__root","title":"src-components-ui-Consult-styles__title","button":"src-components-ui-Consult-styles__button"};